import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uix/uix/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aem-content-fragments-console-overview"
    }}>{`AEM Content Fragments Console Overview`}</h1>
    <p>{`Meet Content Fragments console, multitenant UI service for managing Adobe Experience Manager Content Fragments.`}</p>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-manager-cloud-service/content/sites/administering/content-fragments/content-fragments-console.html"
      }}>{`Content Fragments console`}</a>{` is a multitenant `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/"
      }}>{`Experience Cloud`}</a>{` service that is connected to `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-manager-learn/cloud-service/introduction/what-is-aem-as-a-cloud-service.html"
      }}>{`Adobe Experience Manager as a Cloud Service`}</a>{` environment and allows users to fetch and manage content fragments.`}</p>
    <p>{`The Content Fragments console optimizes access to your Content Fragments, helping you create, search, and manage them by taking administrative actions such as publish, unpublish, copy.`}</p>
    <p>{`The Content Fragments console is dedicated to managing, searching for, and creating Content Fragments. It has been optimized for use in a Headless context, but is also used when creating Content Fragments for use in page authoring.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "63.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/5530d/cfc-console-overview.webp 320w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/0c8fb/cfc-console-overview.webp 640w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/94b1e/cfc-console-overview.webp 1280w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/0b34d/cfc-console-overview.webp 1920w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/d5269/cfc-console-overview.webp 2560w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/ba45c/cfc-console-overview.webp 2836w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/dd4a7/cfc-console-overview.png 320w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/0f09e/cfc-console-overview.png 640w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/bbbf7/cfc-console-overview.png 1280w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/ac7a9/cfc-console-overview.png 1920w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/c7a69/cfc-console-overview.png 2560w", "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/100fa/cfc-console-overview.png 2836w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/uix/docs/static/ebbdf3c353f8ebce0e77df5b9fdac5e2/bbbf7/cfc-console-overview.png",
            "alt": "Contents Fragment Console",
            "title": "Contents Fragment Console",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`As Content Fragments console is a multitenant service, `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-manager-learn/cloud-service/local-development-environment-set-up/overview.html"
      }}>{`traditional approach with AEM development`}</a>{` does not work as it is not possible introduce changes isolated to a single tenant.`}</p>
    <p>{`UI Extensibility allows 3rd party developers to extend and customize Content Fragments console with modern front-end technology stack with JavaScript, Node.js and React. No Java needed!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      